import { Box } from "@chakra-ui/react";
import { AvailabilitySuggestedTime, BusyPeriod } from "./types";
import { timeToPosition, durationToHeight } from "./helpers";

interface CrossColumnOverlayProps {
  selectedTime: Date | undefined;
  suggestedTimes: AvailabilitySuggestedTime[];
  currentMeeting: BusyPeriod | undefined;
  durationMinutes: number;
  slotHeight: number;
  timezone: string;
  // Rendered as two passes: "fill" sits behind the busy blocks, "border" in front,
  // so a busy block overlapping the slot stays visible with the band showing around it.
  layer: "fill" | "border";
}

export default function CrossColumnOverlay({
  selectedTime,
  suggestedTimes,
  currentMeeting,
  durationMinutes,
  slotHeight,
  timezone,
  layer,
}: CrossColumnOverlayProps) {
  const bandHeight = durationToHeight(durationMinutes, slotHeight);
  const isFill = layer === "fill";

  return (
    <Box position="absolute" top={0} left={0} right={0} bottom={0} pointerEvents="none">
      {currentMeeting && (
        <Box
          position="absolute"
          top={`${timeToPosition(new Date(currentMeeting.startTime), slotHeight, timezone)}px`}
          height={`${durationToHeight(
            (new Date(currentMeeting.endTime).getTime() - new Date(currentMeeting.startTime).getTime()) / 60000,
            slotHeight,
          )}px`}
          left={0}
          right={0}
          borderRadius="sm"
          {...(isFill ? { bg: "purple.200" } : { borderWidth: "1px", borderColor: "purple.400" })}
        />
      )}

      {suggestedTimes.map((st) => (
        <Box
          key={st.startTime}
          position="absolute"
          top={`${timeToPosition(new Date(st.startTime), slotHeight, timezone)}px`}
          height={`${bandHeight}px`}
          left={0}
          right={0}
          {...(isFill
            ? { bg: "green.50", opacity: 0.35 }
            : { borderTopWidth: "1px", borderBottomWidth: "1px", borderColor: "green.300", borderStyle: "dashed" })}
        />
      ))}

      {selectedTime && (
        <Box
          position="absolute"
          top={`${timeToPosition(selectedTime, slotHeight, timezone)}px`}
          height={`${bandHeight}px`}
          left={0}
          right={0}
          borderRadius="sm"
          {...(isFill ? { bg: "blue.50", opacity: 0.45 } : { borderWidth: "2px", borderColor: "blue.400" })}
        />
      )}
    </Box>
  );
}
